module.exports = __webpack_public_path__ + "static/media/Auto.08a6d7c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Assurant/Auto.png
// module id = 119
// module chunks = 0